class InputEmailController {

    /* @ngInject */
    constructor(destinationService, passwordCredentialsService) {
        this.destinationService = destinationService;
        this.passwordCredentialsService = passwordCredentialsService;
    }

    $onInit(){
        this.passwordCredentialsService.getUserSecurityContext()
            .then(securityContext => this.userSecurityContext = securityContext);

        this.destinationService.getDestinationOrganization()
            .then(destinationOrganization => {
                this.destinationOrganization = destinationOrganization;
                this.validEmailDomains = this.destinationOrganization ? this.destinationOrganization.securityConfiguration.validEmailDomains : [];
                this.activeEmailDomain = this.validEmailDomains ? this.validEmailDomains[0] : null;
            });

        this.model.$render = () => {
            this.onParentChange();
        };
    }

    onParentChange() {
        this.email = this.model.$viewValue;
        this.validate();
    }

    onChildChange() {
        if (this.domainEnabled && this.email && this.activeEmailDomain) {
            this.model.$setViewValue(this.email + this.activeEmailDomain);
        } else {
            this.model.$setViewValue(this.email);
        }
        this.validate();
    }

    setDomain(domain) {
        this.activeEmailDomain = domain;
        this.onChildChange();
    }

    validate() {
        this.model.$setValidity('invalidDomain', this.validDomain());
    }

    validDomain() {
        if (!this.email) {
            return true;
        }

        if (!this.validEmailDomains) {
            return true;
        }

        if (this.validEmailDomains.length === 0) {
            return true;
        }

        if (this.userSecurityContext === 'EXTRANET') {
            return true;
        }

        return this.validEmailDomains.some(domain => this.emailEndsWithValidDomain(domain));
    }

    emailEndsWithValidDomain(suffix) {
        let inputData = this.email;
        if (this.domainEnabled && this.activeEmailDomain) {
            inputData += this.activeEmailDomain;
        }
        return inputData.indexOf(suffix, inputData.length - suffix.length) !== -1;
    }
}

export let InputEmailComponent = {
    controller: InputEmailController,
    controllerAs: 'vm',
    require: {
        model: 'ngModel'
    },
    templateUrl: 'app/login/email/InputEmailComponent.html',
    bindings: {
        isDisabled: '<?',
        domainEnabled: '<?'
    }
};
